import { gql } from '@apollo/client'
import { stateFragment } from '~/graphql/fragments/state'

export const activeDraftFragment = gql`
  fragment activeDraft on Draft {
    id
    isActive
    event {
      id
    }
    eventType {
      id
    }
    state {
      ...state
    }
  }

  ${stateFragment}
`
